import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { InfoIcon, LogoIcon, UserAccountIcon } from 'components/SvgIcon';
import sidebar from 'layouts/sidebar';
import SidebarItem from 'layouts/SidebarItem';
import history from 'helpers/history.helper';
import { setSidebarActive } from 'core.slice';
import { UserPropTypes } from 'constants/proptypes.constant';

const mapState = state => ({
    sidebarActive: state.core.sidebarActive,
    user: state.auth.user,
    count: state.auth.count,
});
const mapDispatch = { setSidebarActive };
const SidebarCounselor = ({ sidebarActive, setSidebarActive, user, count }) => {
    const { t } = useTranslation();

    const badges = {
        COUNSELOR_CALENDAR: count.reservationToday,
        COUNSELOR_CONSULTATION_RESERVATION: count.reservation,
        COUNSELOR_MESSAGE: count.message,
    };

    return (
        <div id="sidebar-none-user" className="none-sidebar-user sidebar-light">
            <div id="logo">
                <LogoIcon size={32} />
            </div>
            <div id="user-info" className="p-0">
                <ul id="main-navigation" className="navigation">
                    <SidebarItem
                        isActive={sidebarActive === 'profile'}
                        key={'profile'}
                        icon={UserAccountIcon}
                        text={`${user.full_name}`}
                        isTranslate={false}
                        onClick={() => {
                            // if (sidebarActive === 'profile') return;
                            setSidebarActive('profile');
                            history.push('/counselor/account');
                        }}
                    />
                </ul>
            </div>
            <ul id="main-navigation" className="navigation">
                {sidebar.map(item => {
                    if (item.module !== 'counselor') return null;
                    if (item.key.startsWith('COUNSELOR_DETAIL')) return null;
                    let badge;
                    if (Object.prototype.hasOwnProperty.call(badges, item.key)) {
                        badge = badges[item.key];
                    }
                    const isActive = sidebarActive === item.key;
                    return (
                        <SidebarItem
                            isActive={isActive}
                            key={item.key}
                            icon={item.icon}
                            text={item.text}
                            badge={badge}
                            onClick={() => {
                                // if (isActive) return;
                                setSidebarActive(item.key);
                                history.push(item.path);
                            }}
                        />
                    );
                })}
            </ul>
        </div>
    );
};

export default connect(mapState, mapDispatch)(SidebarCounselor);

SidebarCounselor.propTypes = {
    sidebarActive: PropTypes.string,
    setSidebarActive: PropTypes.func.isRequired,
    user: UserPropTypes,
};
